export enum APP_ENV {
  POS = 'pos',
  ONLINE = 'online',
  MAIN = 'main',
  INTERNAL = 'internal',
  KDS = 'kds',
  DASHBOARD = 'dashboard',
  KIOSK = 'kiosk',
  MOM = 'mom',
  UAT = 'uat',
  STAGE = 'stage',
  STAGEV2 = 'stagev2',
}

export const RatingMap: Record<string, number> = {
  ONE: 1,
  TWO: 2,
  THREE: 3,
  FOUR: 4,
  FIVE: 5,
};
